<template>
<div class="md-layout md-gutter">
	<MenuLayout>
		<div slot="slotForm"> 
			<div class="md-layout md-gutter">
				<div class="md-layout-item">
					<statsCard data-background-color="blue">
						<template slot="header">
							<md-icon class="md-size-2x" style="color: white;" >turned_in_not</md-icon>
						</template>

						<template slot="content">
							<p class="category">Suínos Rastreados</p>
							<h3 class="title">{{totalSuinos.toLocaleString('pt-BR', {useGrouping:true})}}
							</h3>
						</template>

						<template slot="footer">
							<div class="stats">
								<md-icon style="color: lightgray;">date_range</md-icon>
								Até o momento
							</div>
						</template>
					</statsCard>
				</div>
				<div class="md-layout-item">
					<statsCard data-background-color="green">
						<template slot="header" style="background: yellow;">
							<md-icon class="md-size-2x" style="color: white;">description</md-icon>
						</template>

						<template slot="content">
							<p class="category">Boletins Sanitários</p>
							<h3 class="title">{{totalBoletins.toLocaleString('pt-BR', {useGrouping:true})}}
							</h3>
						</template>

						<template slot="footer">
							<div class="stats">
								<md-icon style="color: lightgray;">date_range</md-icon>
								Até o momento
							</div>
						</template>
					</statsCard>
				</div>
				<div class="md-layout-item">
					<statsCard data-background-color="brown">
						<template slot="header" style="background: blue;">
							<md-icon class="md-size-2x" style="color: white;">content_copy</md-icon>
						</template>

						<template slot="content">
							<p class="category">Pallets</p>
							<h3 class="title">{{totalPallets.toLocaleString('pt-BR', {useGrouping:true})}}
							</h3>
						</template>

						<template slot="footer">
							<div class="stats">
								<md-icon style="color: lightgray;">date_range</md-icon>
								Até o momento
							</div>
						</template>
					</statsCard>
				</div>
				<div class="md-layout-item">
					<statsCard data-background-color="purple">
						<template slot="header" style="background: orange;">
							<md-icon class="md-size-2x" style="color: white;">assignment_turned_in</md-icon>
						</template>

						<template slot="content">
							<p class="category">Expedições</p>
							<h3 class="title">{{totalExpedicoes.toLocaleString('pt-BR', {useGrouping:true})}}
							</h3>
						</template>

						<template slot="footer">
							<div class="stats">
								<md-icon style="color: lightgray;">date_range</md-icon>
								Até o momento
							</div>
						</template>
					</statsCard>
				</div>
			</div>
			<div class="md-layout md-gutter">
				<div class="md-layout-item">
					<chart-card
						:chart-data="suinosRastreadosYearChart.data"
						:chart-options="suinosRastreadosYearChart.options"
						:chart-responsive-options="suinosRastreadosYearChart.responsiveOptions"
						:chart-type="'Bar'"
						data-background-color="orange">
						<template slot="content">
							<h4 class="chart-title">Suínos Rastreados</h4>
							<p class="chart-category">
								{{rangePesquisaSuinosYear}}
							</p>
						</template>

						<template slot="footer">
							<div class="stats">
							<md-icon>access_time</md-icon>
							{{updatedTimeSuinosYear}}
							</div>
						</template>
					</chart-card>
				</div>
				<div class="md-layout-item">
					<chart-card
						:chart-data="suinosRastreadosMonthChart.data"
						:chart-options="suinosRastreadosMonthChart.options"
						:chart-responsive-options="suinosRastreadosMonthChart.responsiveOptions"
						:chart-type="'Bar'"
						data-background-color="red">
						<template slot="content">
							<h4 class="chart-title">Suínos Rastreados</h4>
							<p class="chart-category">
								{{rangePesquisaSuinosMonth}}
							</p>
						</template>

						<template slot="footer">
							<div class="stats">
							<md-icon>access_time</md-icon>
							{{updatedTimeSuinosMonth}}
							</div>
						</template>
					</chart-card>
				</div>
			</div>
		</div>
	</MenuLayout>
</div>
</template>

<style scoped>
	.md-layout-item {
		height: 40px;
		width: 100%;
		height: 100%;
		display: block;
		content: " ";
		margin: 10px;
	}
</style>
	
<script>

import Vue from 'vue'
import MenuLayout from '.././components/MenuLayout'
import StatsCard from '.././components/StatsCard'
import ChartCard from '.././components/ChartCard'

var menuLayout = Vue.extend(MenuLayout, {});
var statsCard = Vue.extend(StatsCard, {});
var chartCard = Vue.extend(ChartCard, {});

export default {
	name: 'DashBoard',
	methods: {
		getSuinos: function () {
			var _this = this;
			_this.totalSuinos = ""
			var settings = {
				url: _this.$root.urlAPI + 'suinos/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						_this.totalSuinos = response[0].suinos;
					}
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar total de Suínos Rastreados!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		getBoletins: function () {
			var _this = this;
			_this.totalBoletins = ""
			var settings = {
				url: _this.$root.urlAPI + 'boletins/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						_this.totalBoletins = response[0].boletins;
					}
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar total de Boletins Sanitários!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		getPallets: function () {
			var _this = this;
			_this.totalPallets = ""
			var settings = {
				url: _this.$root.urlAPI + 'pallets/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						_this.totalPallets = response[0].pallets;
					}
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar total de Pallets!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		getExpedicoes: function () {
			var _this = this;
			_this.totalExpedicoes = ""
			var settings = {
				url: _this.$root.urlAPI + 'expedicoes/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						_this.totalExpedicoes = response[0].expedicoes;
					}
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar total de Expedições!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		formatDate: function(date) {
			var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('/');
		},
		getSuinosMonthRastreados: function() {
			var _this = this;
			var settings = {
				url: _this.$root.urlAPI + 'suinos/grafico/mes/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					var date = Date();
					var dateTime = new Date(date);
					_this.updatedTimeSuinosMonth = 'Atualizado em ' + _this.formatDate(date) + ' às ' + dateTime.getHours() + ":" + dateTime.getMinutes()
					_this.rangePesquisaSuinosMonth = 'Dados dos últimos 15 dias' 					

					if(response.length > 0){
						var objLabels = [];
						var objData = [];
						var responseReverse = response.reverse();
						responseReverse.forEach(function(item) {
							var label = item[0] + '\n(' + item[1] + ')'
							objLabels.push(label);
							objData.push(item[1]);
						});
						_this.suinosRastreadosMonthChart.options.high = Math.max.apply(Math, objData);
						_this.suinosRastreadosMonthChart.data.labels = objLabels;
						_this.suinosRastreadosMonthChart.data.series = [objData];
					}
					_this.$children[0].$children[2].$children[5].initChart()
					
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar os Suínos Rastreados!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		getSuinosYearRastreados: function() {
			var _this = this;
			var settings = {
				url: _this.$root.urlAPI + 'suinos/grafico/ano/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					var date = Date();
					var dateTime = new Date(date);
					_this.updatedTimeSuinosYear = 'Atualizado em ' + _this.formatDate(date) + ' às ' + dateTime.getHours() + ":" + dateTime.getMinutes()
					_this.rangePesquisaSuinosYear = 'Dados dos últimos 12 meses'

					if(response.length > 0){
						var objLabels = [];
						var objData = [];
						response.forEach(function(item) {
							var label = item[0] + '\n(' + item[1] + ')'
							objLabels.push(label);
							objData.push(item[1]);
						});
						_this.suinosRastreadosYearChart.options.high = Math.max.apply(Math, objData);
						_this.suinosRastreadosYearChart.data.labels = objLabels;
						_this.suinosRastreadosYearChart.data.series = [objData];
					}
					_this.$children[0].$children[2].$children[4].initChart()
				})
				.fail(function (response) {
					_this.$children[0].msgErrorSistema = 'Erro ao carregar os Suínos Rastreados!';
					_this.$children[0].$refs.msgErrorSistema.open();
				})
		},
		userLogged: function() {
			this.getSuinos();
			this.getBoletins();
			this.getPallets();
			this.getExpedicoes();
			this.getSuinosMonthRastreados();
			this.getSuinosYearRastreados();
		}
	},
	mixins: [
		menuLayout,
		statsCard,
		chartCard
	],
	components: {
		MenuLayout,
		StatsCard,
		ChartCard
	},

	mounted() {
		if (this.$root.verifyUserLogged())
		{
			this.userLogged();
		}
	},

	data: () => ({
		totalSuinos: '',
		totalBoletins: '',
		totalPallets: '',
		totalExpedicoes: '',
		updatedTimeSuinosMonth: '',
		rangePesquisaSuinosMonth: '',
		updatedTimeSuinosYear: '',
		rangePesquisaSuinosYear: '',
		suinosRastreadosMonthChart: {
			data: {
				labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
				series: [ [542, 2443, 4320, 1780, 3553, 4453, 2326, 434, 1568, 3610, 756, 895] ]
			},
			options: {
				axisX: {
					showGrid: false
				},
				low: 0,
				high: 8000,
				chartPadding: {
					top: 30,
					right: 5,
					bottom: 5,
					left: 0
				}
			},
			responsiveOptions: [
				['screen and (max-width: 640px)', {
				seriesBarDistance: 2,
					axisX: {
						labelInterpolationFnc: function (value) {
							return value[0]
						}
					}
				}]
			]
		},
		suinosRastreadosYearChart: {
			data: {
				labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
				series: [ [542, 2443, 4320, 1780, 3553, 4453, 2326, 434, 1568, 3610, 756, 895] ]
			},
			options: {
				axisX: {
					showGrid: false
				},
				low: 0,
				high: 8000,
				chartPadding: {
					top: 30,
					right: 0,
					bottom: 5,
					left: 0
				}
			},
			responsiveOptions: [
				['screen and (max-width: 640px)', {
				seriesBarDistance: 1,
					axisX: {
						labelInterpolationFnc: function (value) {
							return value[0]
						}
					}
				}]
			]
		}
	})
}
</script>



// WEBPACK FOOTER //
// src/components/DashBoard.vue